<template>
  <div class="checklist" :class="{ 'left-align' : enable, 'no-check': hideCheck }">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="'item' + index"
        v-html="item"
        class="item"
        :class="{ selected: itemSelected(index), clickable: enable }"
        @click="selectItem(index)">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Checklist',
  props: {
    enable: {
      type: Boolean,
      required: false,
      default: false
    },
    checkedList: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    allChecked: {
      type: Boolean,
      required: false,
      default: false
    },
    hideCheck: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      list: [
        '<strong>Gérer la pose des RTT restant jusqu’à fin décembre.</strong> Les RTT non pris seront perdus',
        '<strong>Guillaume souhaite modifier son jour de repos du 27/10</strong> pour le positionner le 30/10',
        '<strong>Poser 7h de récupération à chaque collaborateur</strong>',
        '<strong>Eric sera en congé du 19 au 22/10</strong>',
        '<strong>Planifier les samedis : 7 personnes doivent être présentes dont 1 cadre</strong> – idéalement sans faire d’heures excédentaires',
        '<strong>Sylvain doit poursuivre sa formation à distance, 2 demi-journées par semaine.</strong> Voir avec Nicolas ou Kevin pour assurer la fermeture ces jours-là.',
        '<strong>Jean-Baptiste prend son congé paternité à partir du 20 octobre</strong>',
        '<strong>Aline est en visite médicale le 29/10 de 10h à 11h30</strong>'
      ],
      selectedItems: this.checkedList
    }
  },
  methods: {
    selectItem (itemIndex) {
      if (this.enable) {
        if (this.itemSelected(itemIndex)) {
          this.selectedItems.splice(this.selectedItems.indexOf(itemIndex), 1)
        } else {
          this.selectedItems.push(itemIndex)
        }
        this.$emit('set-list', this.selectedItems)
      }
    },
    itemSelected (itemIndex) {
      return this.allChecked ? true : this.selectedItems.includes(itemIndex)
    }
  }
}
</script>

<style lang=scss>
.checklist {
  font-family: $secondary-font;
  &.left-align {
    text-align: left;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li.item {
      padding-right: 30px;
      vertical-align: top;
      display: inline-block;
      width: 50%;
      text-align: left;
      margin-top: 10px;
      position: relative;
      padding-left: 30px;
      font-size: 0.9rem;
      min-height: 34px;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 18px;
        height: 18px;
        box-shadow: inset 1px 2px 3px rgba(0, 0, 0, 0.35);
        border-radius: 2px;
        border: 1px solid #2e2e2e;
        background-color: #fff;
        background-position: center;
        background-size: 12px 9px;
        background-repeat: no-repeat;
      }
      &.selected {
        &:before {
          background-image: url('../assets/check.svg');
        }
      }
      &.clickable {
        cursor: pointer;
        &:hover {
          &:before {
            background-image: url('../assets/check-hover.svg');
          }
        }
      }
      ul {
        list-style-type: none;
      }
    }
  }
  &.no-check {
    ul {
      list-style-type: circle;
      list-style-position: inside;
      li.item {
        padding-left: 20px;
        &:before {
          content: "•";
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
          box-shadow: none;
        }
      }
    }
  }
}
</style>
